import {
    Text,
    Divider,
    Stack,
    Box,
    SimpleGrid,
    Badge,
  } from "@mantine/core";
  import { useState, useEffect } from "react";
  
  interface Props {
    carePlan: any;
  }
  
  const CarePlanResource: React.FC<Props> = ({ carePlan }) => {
    const [subject, setSubject] = useState<any | undefined>(undefined);
    const [goal, setGoal] = useState<any[] | undefined>(undefined);
    const [activity, setActivity] = useState<any[] | undefined>(undefined);
  
    useEffect(() => {
      if (carePlan.subject) {
        setSubject(carePlan.subject);
      }
      if (carePlan.goal) {
        setGoal(carePlan.goal);
      }
      if (carePlan.activity) {
        setActivity(carePlan.activity);
      }
    }, [carePlan]);
  
    return (
      <Stack spacing="xs">
        <Text weight="bold" size="xl" >
          Care Plan
        </Text>
        <Divider />
        <SimpleGrid cols={2} spacing="sm">
          {/* Column 1: Label */}
          <Box>
            <Text weight={500} color="dimmed">
              ID
            </Text>
          </Box>
          {/* Column 2: Value */}
          <Box>
            <Text color="dark">{carePlan.id}</Text>
          </Box>
  
          <Box>
            <Text weight={500} color="dimmed">
              Status
            </Text>
          </Box>
          <Box>
            <Badge color="green" variant="filled">
              {carePlan.status}
            </Badge>
          </Box>
  
        
  
          <Box>
            <Text weight={500} color="dimmed">
              Title
            </Text>
          </Box>
          <Box>
            <Text color="dark">{carePlan.title}</Text>
          </Box>
  
          {subject && (
            <>
              <Box>
                <Text weight={500} color="dimmed">
                  Subject
                </Text>
              </Box>
              <Box>
                <Text color="dark">{subject.reference}</Text>
              </Box>
            </>
          )}
  
          {goal && (
            <>
              <Box>
                <Text weight={500} color="dimmed">
                  Goal Reference
                </Text>
              </Box>
              <Box>
                {goal.map((g) => (
                  <Text key={g.reference} color="dark">
                    {g.reference}
                  </Text>
                ))}
              </Box>
            </>
          )}
  
          {activity && (
            <>
              <Box>
                <Text weight={500} color="dimmed">
                  Activity
                </Text>
              </Box>
              <Box>
                {activity.map((a) => (
                  <Text key={a.reference.reference} color="dark">
                    {a.reference.display}
                  </Text>
                ))}
              </Box>
            </>
          )}
        </SimpleGrid>
        <Divider />

      </Stack>
    );
  };
  
  export default CarePlanResource;
  